export default __webpack_public_path__ + "static/media/NN.dcdf6070.png";